// extracted by mini-css-extract-plugin
export default {"actions":"V8h2kUslOoUw00EDJ0XJ","likes":"cGdU0Xk6lQiGKTZKCe30"};